<main class="auth-wrap">
    <div class="loading-in-tab" *ngIf="tokenValid == 'validating'">
        <img src="/assets/images/loading.gif" alt="">
        <h5>Validating URL...</h5>
    </div>
    <div class="content"  *ngIf="tokenValid != 'validating'">
        <img src="assets/images/logo-main.svg" class="img-fluid d-block m-auto" alt="logo">
        <!-- <h4>Password reset link will be sent to your email.</h4> -->
        <h2 *ngIf="tokenValid==false" class="warning">Invalid URL</h2>
        <h2 *ngIf="tokenValid==true">Set New Password</h2>
        <div class="form-wrap" *ngIf="tokenValid==true">
            <span class="form-error" *ngIf="passwordNotMatch == 'error'">Passwords are not matching</span>
            <form [formGroup]="setNewPasswordForm">
                <div class="input-wrapp">
                    <div class="form-group">
                        <input type="{{passwordShow?'text':'password'}}" formControlName="password" class="form-control" id="passwordInput" validatePassword="password" placeholder="Password">
                        <a class="passsword-visible"  [class.text]="passwordShow"  (click)="passwordShow = !passwordShow"><i class="icon"></i></a> 
                        <i #passwordInfo="ngbTooltip" class="icon-information" placement="right" ngbTooltip="Password should have minimum 8 and maximum 50 letters, should have atleast one uppercase, one lowercase ,one  symbol and one number"></i>
                        <!-- <label for="passwordInput" *ngIf="setNewPasswordForm.get('password').value == ''">Old password<sup>*</sup></label>
                        <form-validation-message [control]="setNewPasswordForm.controls.password"></form-validation-message> -->
                    </div>
                    <div class="form-group">
                        <input type="{{confirmPasswordShow?'text':'password'}}" formControlName="confirmPassword" class="form-control" validatePassword="confirmPassword" id="confirmPasswordInput" placeholder="Confirm Password">
                        <a class="passsword-visible"  [class.text]="confirmPasswordShow"  (click)="confirmPasswordShow = !confirmPasswordShow"><i class="icon"></i></a> 
                        <!-- <label for="confirmPasswordInput" *ngIf="setNewPasswordForm.get('confirmPassword').value == ''">New password<sup>*</sup></label>
                        <form-validation-message [control]="setNewPasswordForm.controls.confirmPassword"></form-validation-message> -->
                    </div>
                </div>
                <button type="submit" class="btn btn-green" (click)="sendNewPassword()" [disabled]="!setNewPasswordForm.valid">Set Password</button>
            </form>
        </div>

    </div>
</main>